<template>
  <div class="upload-file-cmp">
    <!-- <div v-for="(item, index) of fileList" :key="index" class="file-item">
      <span>{{item.url | nameFilter}}</span>
      <i class="el-icon-close cancel" @click="remove(index)" />
    </div> -->
    <el-upload
      class="avatar-uploader"
      :disabled="disabled"
      :action="uploadUrl"
      :show-file-list="false"
      :on-success="onSuccess"
      :before-upload="beforeUpload"
      :headers="{ Authorization }"
      :data="{ uploadType: 'PC' }"
    >
      <img v-if="value" :src="value" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <!-- <el-upload
      class="avatar-uploader"
      :action="uploadUrl"
      :show-file-list="false"
      :headers="{ Authorization }"
      :data="{ uploadType: 'PC' }"
      :before-upload="beforeUpload"
      :on-success="onSuccess"
    >
      <img v-if="value" :src="value" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload> -->
    <!-- <el-upload
      class="upload-demo"
      :action="uploadUrl"
      :headers="{ Authorization }"
      :data="{ uploadType: 'PC' }"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-success="onSuccess"
    >
    </el-upload> -->
  </div>
</template>

<script>
const baseApi = process.env.VUE_APP_BASE_API;
export default {
  props: {
    // limit: {
    //   type: Number,
    //   default: 1
    // },
    disabled:{
      type:Boolean,
      default:false
    },
    value: {
      type: String,
      default: ""
    }
  },
  filters: {
    nameFilter(val) {
      const reg = new RegExp(/\/.{32}:/);
      const str = reg.exec(val)[0];
      const vals = val.split(str);
      return vals[vals.length - 1];
    }
  },
  data() {
    return {
      uploadUrl: baseApi + "business/commonLogin/upload",
      Authorization: sessionStorage.getItem("token"),
      loading: false
      // fileList: []
    };
  },
  // watch: {
  //   value() {
  //     this.initData();
  //   }
  // },
  created() {
    // this.initData();
  },
  methods: {
    onSuccess(res, file) {
      console.log(res.d);
      this.value = res.d;
      this.$emit("input", this.value);
    },
    beforeUpload(file) {}
    // initData() {
    //   const { value } = this;
    //   if (!value) {
    //     this.fileList = [];
    //   } else if (typeof value === "string") {
    //     this.fileList = value.split(",").map(item => ({
    //       status: "success",
    //       url: item
    //     }));
    //   } else {
    //     this.fileList = value.map(item => ({
    //       status: "success",
    //       url: item
    //     }));
    //   }
    //   console.log(this.fileList);
    // },
    // beforeUpload() {
    //   if (this.fileList.length >= this.limit) {
    //     this.$message.warning(`当前限制选择 ${this.limit} 个文件`);
    //     return false;
    //   }
    // },
    // onSuccess(response, file, fileList) {
    //   console.log(response.d);
    //   this.fileList.push({
    //     status: "success",
    //     url: response.d
    //   });
    //   this.submitData(this.fileList);
    // },
    // remove(index) {
    //   this.fileList.splice(index, 1);
    //   this.submitData(this.fileList);
    // },
    // submitData(fileList) {
    //   const urls = fileList.map(item => {
    //     if (item.response) {
    //       return item.response.d;
    //     } else {
    //       return item.url;
    //     }
    //   });
    //   console.log(urls);
    //   if (typeof this.value === "string") {
    //     this.$emit("input", urls.join(","));
    //     this.$emit("change", urls.join(","));
    //   } else {
    //     this.$emit("input", urls);
    //     this.$emit("change", urls);
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Upload.vue